import instancias from "../../API/backend";
import { validarRespuesta } from '../../Base/Services/crypto';
import axios from 'axios';



export const PrivateInterceptorIPS = async (URL, method, body = undefined) => {
    let respuesta = null;
    const promesa = await fetch(`${instancias.API_URL_IPS}/${URL}?${Date.now()}`, {
        method: method,
        headers: {
            "Content-Type": "application/json",
            'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
        },
        body: JSON.stringify(body)
    })

    await promesa.json()
        .then(function (res) {
            // console.log({res});
            // alert('stop')
            if (!res.data.valid) {
                validarRespuesta(res);
            }
            respuesta = res?.data;
        })
        .catch((error) => {
            respuesta = { error: error };
            console.error(respuesta);
        })
    return respuesta;
}


export const PrivateInterceptorBC = async (id, fecha, method, body = undefined) => {

    try {
        const response = await axios.get(`https://bchapi-am.azure-api.net/api/v1/indicadores/619/cifras/2024-07-18?formato=Json&clave=610a7bca571243b3a172dd97db1b2900`,)
        console.log(response);
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }


    let respuesta = null;
    const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
    const apiUrl = `https://bchapi-am.azure-api.net/api/v1/indicadores/619/cifras/2024-07-18?formato=Json&clave=610a7bca571243b3a172dd97db1b2900`

    const promesa = await fetch(apiUrl, {
        method: method,
        cors: 'Access-Control-Allow-Origin',
        mode: 'no-cors',
        headers: {
            // "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            // 'x-access-token': localStorage.getItem(process.env.REACT_APP_ClaveBC),
            // 'Ocp-Apim-Subscription-Key': localStorage.getItem(process.env.REACT_APP_ClaveBC)
            'clave': process.env.REACT_APP_ClaveBC,
        },
        body: JSON.stringify(body)
    });

    await promesa.json()
        .then(function (res) {
            // console.log({res});
            // alert('stop')
            if (!res.data.valid) {
                validarRespuesta(res);
            }
            respuesta = res?.data;
        })
        .catch((error) => {
            respuesta = { error: error };
            console.error(respuesta);
        });

    // return respuesta;
}
